import { EventEmitter } from "eventemitter3";
import { SoundManager } from "./SoundManager";
import { GroupConfig } from "./Config";
import { Sound } from "./Sound";

export class SoundGroup extends EventEmitter {
    public manager: SoundManager;
    public name: string;
    public current?: Sound;
    public config: GroupConfig;
    public sounds: Sound | null[];
    public interruptSelf: boolean;
    public interruptGroup: boolean;
    public poly: number;

    private _muted: boolean;
    public get muted() {
        return this._muted;
    }
    public set muted(value) {
        this._muted = value;
        this.manager.updateMuteState();
    }

    private _paused: boolean;
    public get paused() {
        return this._paused;
    }
    public set paused(value) {
        this._paused = value;
        this.manager.updatePauseState();
    }

    constructor(manager: SoundManager, config?: GroupConfig) {
        super();
        this.manager = manager;
        this.config = config || {};
        this.name = this.config.name || "";
        this.muted = this.config.muted || false;
        this.paused = this.config.paused || false;
        this.interruptSelf = !!this.config.interruptSelf;
        this.interruptGroup = !!this.config.interruptGroup;
    }
}
